module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_oc-316b66355bbdb413b9dfd44c4c0cfb0a.png";